import { Input, Collapse, Space } from "antd";
import React from "react";
import moment from "moment";
import {
  AnnotationSettings,
  DestructiveExpirationSettings,
  DocumentSettings,
  RecycleBinSettings,
  RetentionSettings,
  FlatFileSettings,
  getAnnotationSettingsDefaultConfigs,
  getDestructiveExpirationSettingsDefaultConfigs,
  getDocumentDefaultConfigs,
  getRecycleBinDefaultSettings,
  getRetentionSettingsDefaultConfigs,
  getFlatFileDefaultConfigs,
} from "./MyDocsElements";

// console.log(Object.keys(el=>))

export const getMyDocsDefaultConfigs = {
  ...getDocumentDefaultConfigs,
  ...getAnnotationSettingsDefaultConfigs,
  ...getDestructiveExpirationSettingsDefaultConfigs,
  ...getRecycleBinDefaultSettings,
  ...getRetentionSettingsDefaultConfigs,
  ...getFlatFileDefaultConfigs,
};

export const MyDocsConfigFilter = (allindexes, config) => {
  if (
    config !== undefined &&
    typeof config.annotation_cutoff_time === "string"
  ) {
    config.annotation_cutoff_time = moment(config.annotation_cutoff_time);
  }
};

function MyDocs(props) {
  return (
    <div>
      <Collapse defaultActiveKey="1_1" expandIconPosition="right">
        <Collapse.Panel header="Document Settings" key="1_1">
          <DocumentSettings
            _id={props.app_id}
            formItemLayout={props.formItemLayout}
            config={props.config}
            updateValue={props.updateValue}
          />
        </Collapse.Panel>
        {/* <Collapse.Panel header="Annotation Settings">
                    <AnnotationSettings 
                    _id={props.app_id}
                    formItemLayout={props.formItemLayout} 
                    config={props.config}
                    updateValue={props.updateValue}
                    />
                </Collapse.Panel>
                <Collapse.Panel header="Retention Settings">
                    <RetentionSettings 
                    _id={props.app_id}
                    formItemLayout={props.formItemLayout} 
                    config={props.config}
                    updateValue={props.updateValue}
                    />
                </Collapse.Panel>
                <Collapse.Panel header="Destructive/Expiration Settings">
                    <DestructiveExpirationSettings 
                    _id={props.app_id}
                    formItemLayout={props.formItemLayout} 
                    config={props.config}
                    updateValue={props.updateValue}
                    />
                </Collapse.Panel>
                <Collapse.Panel header="Recycle Bin Settings">
                    <RecycleBinSettings 
                    _id={props.app_id}
                    formItemLayout={props.formItemLayout} 
                    config={props.config}
                    updateValue={props.updateValue}
                    />
                </Collapse.Panel>
                <Collapse.Panel header="Flat File Settings">
                    <FlatFileSettings 
                    _id={props.app_id}
                    formItemLayout={props.formItemLayout} 
                    config={props.config}
                    updateValue={props.updateValue}
                    />
                </Collapse.Panel> */}
      </Collapse>
    </div>
  );
}

export default React.memo(MyDocs);
